var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCupWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 513",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,513.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 5093 c2 -16 118 -1070 258 -2343 140 -1273 262 -2343 271 -2377 42 -162 173 -296 341 -350 l74 -23 1359 0 1359 0 74 23 c168 54 299 188 341 350 9 34 131 1104 271 2377 140 1273 256 2327 258 2343 l4 27 -2307 0 -2307 0 4 -27z m4028 -520 c-5 -37 -105 -964 -105 -977 0 -3 -729 -6 -1620 -6 -891 0 -1620 3 -1620 8 0 4 -25 230 -55 502 -30 272 -55 498 -55 503 0 4 779 7 1730 7 l1730 0 -5 -37z m-1658 -1737 c304 -364 561 -779 652 -1051 94 -281 35 -561 -162 -771 -138 -148 -311 -228 -517 -240 -223 -13 -413 60 -576 221 -215 212 -281 497 -183 790 89 267 304 618 617 1008 52 64 97 117 101 117 3 0 34 -33 68 -74z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupWater);
export default __webpack_public_path__ + "static/media/CupWater.318dd96e.svg";
export { ForwardRef as ReactComponent };